// src/constants/scopeOptions.js

const scopeOptions = [
    {value:"check_balance", label:"Check Balance"},
  { value: "read_bills", label: "Read Bills" },
  { value: "read_plans", label: "Read Plans" },
  { value: "read_packs", label: "Read Packs" },
  { value: "read_billers", label: "Read Billers" },
  { value: "read_regions", label: "Read Regions" },
  { value: "bill_validate", label: "Bill Validate" },
  { value: "read_operators", label: "Read Operators" },
  { value: "raise_complaint", label: "Raise Complaint" },
  { value: "get_biller_plans", label: "Get Biller Plans" },
  { value: "read_transactions", label: "Read Transactions" },
  { value: "get_biller_status", label: "Get Biller Status" },
  { value: "register_complain", label: "Register Complain" },
  { value: "read_agent_balance", label: "Read Agent Balance" },
  { value: "create_transactions", label: "Create Transactions" },
  { value: "get_biller_by_region", label: "Get Biller By Region" },
  { value: "read_operator_circle", label: "Read Operator Circle" },
  { value: "check_complain_status", label: "Check Complain Status" },
  { value: "get_biller_categories", label: "Get Biller Categories" },
  { value: "get_biller_by_category", label: "Get Biller By Category" },
  { value: "check_complaint_status", label: "Check Complaint Status" },
  { value: "read_biller_categories", label: "Read Biller Categories" },
  { value: "bill_payment_validation", label: "Bill Payment Validation" },
  { value: "get_bill_payment_txn_status", label: "Get Bill Payment Txn Status" },
  { value: "pay_bill_mob", label: "Pay Bill Mob" },
  { value: "get_bill_mob", label: "Get Bill Mob" },
  { value: "pay_bill_int", label: "Pay Bill INT" },
  { value: "get_bill_int", label: "Get Bill INT" },
  { value: "pay_bill_agt", label: "Pay Bill AGT" },
  { value: "get_bill_agt", label: "Get Bill AGT" },
   { value: "prepaid_bill_payment_txn", label: "Prepaid Bill Payment Txn" },
  { value: "prepaid_bill_payment_txn_status", label: "Prepaid Bill Payment Txn Status" },
  { value: "prepaid_bill_complaint", label: "Prepaid Bill Complaint" },
  { value: "prepaid_bill_complaint_status", label: "Prepaid Bill Complaint Status" },
  { value: "prepaid_bill_check_operator", label: "Prepaid Bill Check Operator" },
  { value: "prepaid_bill_get_operator", label: "Prepaid Bill Get Operator" },
  { value: "prepaid_bill_fetch_plans", label: "Prepaid Bill Fetch Plans" },
  { value: "prepaid_bill_get_regions", label: "Prepaid Bill Get Regions" },
  { value: "prepaid_bill_agent_statements", label: "Prepaid Bill Agent Statements" },
  { value: "prepaid_bill_recharge_type", label: "Prepaid Bill Recharge Type" },
];

export default scopeOptions;
